import { useEffect, useState } from "react";

import ModalComponents from "../../components/modals/ModalComponents";

export default function NotFound({ setEnteredUser }: any) {
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const isLocalhost = window.location.hostname === "localhost";

    if (!isLocalhost && window.location.pathname === "/") {
      window.location.href = "https://vam30.com";
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://vam30.com";
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-10 shadow-button_sm_hover ">
      <img
        src="/images/4041.svg"
        alt="404 images"
        className="absolute bottom-0 left-0"
      />
      <img
        src="/images/4042.svg"
        alt="404 images"
        className="absolute top-0 right-0"
      />
      <img
        src="/images/4043.svg"
        alt="404 images"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2  "
      />

      <div className="flex  gap-4 absolute top-3/4 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
        <button
          onClick={() => (window.location.href = "https://vam30.com")}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007BFF",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          برگشت به صفحه اصلی
        </button>
      </div>
      {showLogin && (
        <ModalComponents
          setEnteredUser={setEnteredUser}
          onClose={() => setShowLogin(false)}
          navigateHere={"/"}
        />
      )}
    </div>
  );
}

// in this code, I want that after 15 sec, user redirect auto to vam30.com
